<div class="my-container">
  <ngx-loading [show]="isLoading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
</div>
<router-outlet></router-outlet>
